

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { t, setLanguage, getLanguage } from '../i18n';

const FooterBar = () => {
  return (
    <footer style={styles.footer}>
      <Link to="/privacy-policy" style={styles.link}>
        {t('privacyTitle')}
      </Link>
      <span style={styles.copyright}>
        © 2026 Neurone1664. {t('allRightsReserved')}
      </span>
    </footer>
  );
};

	const styles = {
		footer: {
			width: '100%',
			background: 'var(--green-eucalyptus, #2ecc40)',
			color: 'var(--white-off, #fff)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '38px',
			minHeight: '38px',
			padding: '0',
			position: 'fixed',
			left: 0,
			bottom: 0,
			zIndex: 1000,
			fontFamily: `'Montserrat', sans-serif`,
			gap: '16px',
			boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
		},
		label: {
			marginRight: '8px',
			fontSize: '18px',
		},
		button: {
			background: 'none',
			border: 'none',
			color: 'inherit',
			fontSize: '18px',
			cursor: 'pointer',
			margin: '0 8px',
			padding: '4px 8px',
			borderRadius: '4px',
			transition: 'background 0.2s',
		},
		   link: {
			   color: 'inherit',
			   textDecoration: 'underline',
			   fontSize: '16px',
			   marginLeft: '16px',
			   cursor: 'pointer',
		   },
		   copyright: {
			   marginLeft: '24px',
			   fontSize: '14px',
			   opacity: 0.8,
		   },
	};

export default FooterBar;
